import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-forum',
  templateUrl: './business-forum.component.html',
  styleUrls: ['./business-forum.component.css']
})
export class BusinessForumComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
